import { useContext } from 'react';
import { MovContext } from 'contexts/movementsContext/MovContext';

export const useMovContext = () => {
	return useContext(MovContext);
};
